// extracted by mini-css-extract-plugin
module.exports = {"activity-collapsed-row":"activity-collapsed-row___2kFyi","residue":"residue___2Gbu1","title":"title___2bzGz","group":"group___3DC15","show-button":"show-button___3rzw4"};